import { Check } from "lucide-react";
import { Reveal } from "@/components/site/Motion";

export const SystemEditions = ({ systems }) => (
  <div className="grid lg:grid-cols-2 gap-5">
    {systems.map((s, i) => (
      <Reveal key={s.name} delay={i * 0.1} className="h-full">
        <article className={`h-full rounded-[28px] p-8 sm:p-10 ${i === 0 ? "bg-white border border-[#E3E2DA]" : "bg-[#070B2E] text-white"}`} data-testid={`system-edition-${i}`}>
          <p className={`font-mono text-xs uppercase tracking-[0.2em] ${i === 0 ? "text-[#0B14A0]" : "text-[#7FE3EA]"}`}>Fokus: {s.focus}</p>
          <h3 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mt-4">{s.name}</h3>
          <p className={`mt-4 leading-relaxed ${i === 0 ? "text-[#3A3F5C]" : "text-[#C9CDEA]"}`}>{s.text}</p>
          <ul className="mt-8 grid sm:grid-cols-2 gap-x-6 gap-y-3">
            {s.features.map((f) => (
              <li key={f} className="flex items-start gap-2.5 text-[15px]">
                <Check className={`w-4 h-4 mt-1 shrink-0 ${i === 0 ? "text-[#0B14A0]" : "text-[#7FE3EA]"}`} />
                <span>{f}</span>
              </li>
            ))}
          </ul>
        </article>
      </Reveal>
    ))}
  </div>
);
